import { Route } from '@angular/router';
import { HomeComponent } from './home.component';
import { Config } from 'src/client/environments/environment';
import { AuthGluuComponent } from '../authgluu/authgluu.component';

export const HomeRoutes: Route[] = [
  {
    path: '',
    component: Config.IDENTITY_PROVIDER == "AUTH0" ? HomeComponent : AuthGluuComponent
  }
];
